module.exports = __webpack_public_path__ + "img/atm.fa42fe81.svg";